<template>
    <div class="site" >
        <div class="btns" v-if="user.role.includes('0')||user.role.includes('2') ||user.id == model.user_id">
            <!-- 管理员和有权限的可以 -->
             <!-- <p>{{ ischeck2 + checkall }}</p> -->
            <template v-if="user.role.includes('0') || user.role.includes('2')">
                <template v-if="commonStore.ischecke == '2'">
                    <p v-if="!check_status =='1'"  @click="setcheck(1)" class="isgreen hand">项目管理方核查</p>
                    <p v-else-if="check_status" @click="setcheck(0)" class="green hand" >项目管理方已核查</p>
                </template>
                <template v-else>
                    <p v-if="!check_status == '1'" @click="setcheck(1)" class="isgreen hand">未核查</p>
                    <p v-else-if="check_status" @click="setcheck(0)" class="green hand" >已核查</p>
    
                </template>
            
            </template>
<!-- // 角色：0管理员、1普通医生、2、核查人员 -->

<!-- //质疑的状态：0=待处理, 1=已处理, 2=已撤销, 3=已确认 -->
            <p v-if="!['0', '1'].includes(question_status) && (user.role.includes('0')|| user.role.includes('2'))" 
            @click="questionfun('add')" class="yellow hand">质疑</p>

            <!-- <p v-if="question_status =='0'&& (user.role.includes('0')|| user.role.includes('2'))" 
            @click="questionfun('revoke')" class="yellow hand" >撤销质疑</p> -->

            <!-- 本人和管理员才能关闭 -->
            <p v-if="question_status =='0'&& (user.id == model.user_id||user.role.includes('0'))" @click="questionfun('process')" class="yellow hand" >处理质疑</p>

            <p v-if="question_status =='1'&& (user.role.includes('0')|| user.role.includes('2'))" @click="closequestion" style="background-color: gray;" class="hand">关闭</p>

        </div>
        <div v-if="questionmsg" class="question">
            <span v-for="(item, index) in questionmsg" :key="index">
                {{item.content}}
            </span>
            <!-- 质疑:{{ questionmsg }}-->
        </div> 
    </div>
    <!-- 操作弹窗 -->
    <div v-if="questionshow" class="dialog">
        <div class="box" ref="dialogBox" :style="dialogPosition">
            <p v-if="questiontype == 'add'" class="title draggable-header" @mousedown="startDrag">发布质疑</p>
            <!-- <p v-else-if="questiontype == 'revoke'" class="title">撤销质疑</p> -->
            <p v-else class="title draggable-header" @mousedown="startDrag">处理质疑</p>

            <div class="content">
                <div class=""><p>患者姓名:</p><p>{{ getval('患者姓名') }}</p></div>
                <div class="report"><p>质疑访视期:</p><p>{{ props.period }}</p></div>
                <!-- 质疑内容就是标题 -->
                <div class="text">
                    <p>质疑内容:</p>
                    <p v-if="questiontype == 'add'"><el-input v-model="title"  placeholder="请输入质疑内容" /></p>
                    <p v-else>{{ inquiry_content }}</p>
                </div>
                <div class="text">
                    <p>质疑原因:</p>
                    <p v-if="questiontype == 'add'"><el-input
                        v-model="addtextarea"
                        :rows="6"
                        type="textarea"
                        placeholder="请输入质疑原因"
                        /> 
                    </p>
                    <!-- 撤销和处理的质疑原因 -->
                    <p v-else>{{inquiry_reason}}</p>
                </div>
                <div v-if="questiontype == 'revoke'"  class="text">
                    <p>撤销质疑原因:</p>
                    <p ><el-input
                        v-model="revoketextarea"
                        :rows="6"
                        type="textarea"
                        placeholder="请输入撤销质疑原因"
                        /> 
                    </p>
                </div>
                <div v-if="questiontype == 'process'"  class="text">
                    <p>处理质疑说明:</p>
                    <p ><el-input
                        v-model="processtextarea"
                        :rows="6"
                        type="textarea"
                        placeholder="请输入处理质疑说明"
                        /> 
                    </p>
                </div>
            </div>
            <div v-if="questiontype == 'add'" class="footer">
                <el-button @click="questionshow = false">取消</el-button>
                <el-button type="primary" @click="addquestion">提交</el-button>
            </div>
            <div v-else-if="questiontype == 'revoke'" class="footer">
                <el-button @click="questionshow = false">取消</el-button>
                <el-button type="primary" @click="revokequestion">提交</el-button>
            </div>
            <div v-else class="footer">
                <el-button @click="questionshow = false">取消</el-button>
                <el-button type="primary" @click="processquestion">提交</el-button>
            </div>
        </div>
        
    </div>
   
</template>
<script setup>
import { ref, reactive, onMounted , watch , computed} from 'vue'
import {useCommonStore} from "@/stores/common.js"
import { useUserStore } from "@/stores/user";
// 拿到医生信息
const user = useUserStore()
// 拿到医生信息
const commonStore = useCommonStore()
const props = defineProps({
    period:{//质疑访视期
        type: String,
        default: ''
    },
    text:{//质疑标题
        type: String,
        default: ''
    
    },
    data:{//患者所有信息
        type: Object,
        default: {}
    }


})



//质疑标题
const title = ref(props.text)
//质疑填写标题
const inquiry_content = ref('')
// 质疑内容
const questionmsg = ref([])
//质疑原因
const inquiry_reason = ref('')
// 质疑弹窗
const questionshow = ref(false)
// 质疑原因
const addtextarea = ref('')
// 撤销质疑原因
const revoketextarea = ref('')
//质疑状态
const question_status = ref('')
//处理质疑说明
const processtextarea = ref('')
const questionid = ref('')
//质疑的类型add,revoke,process
const questiontype = ref()

// 拖动相关
const dialogBox = ref(null)
const dialogPosition = ref({
    position: 'fixed',
    left: '50%',
    top: '10%',
    transform: 'translateX(-50%)'
})
const isDragging = ref(false)
const dragStart = ref({ x: 0, y: 0 })
const dialogStart = ref({ left: 0, top: 0 })

const startDrag = (e) => {
    isDragging.value = true
    dragStart.value = { x: e.clientX, y: e.clientY }
    
    // 获取当前对话框的位置
    const box = dialogBox.value
    const rect = box.getBoundingClientRect()
    dialogStart.value = { left: rect.left, top: rect.top }
    
    // 移除transform，使用固定定位
    dialogPosition.value = {
        position: 'fixed',
        left: rect.left + 'px',
        top: rect.top + 'px',
        transform: 'none'
    }
    
    document.addEventListener('mousemove', onDrag)
    document.addEventListener('mouseup', stopDrag)
    e.preventDefault()
}

const onDrag = (e) => {
    if (!isDragging.value) return
    
    const deltaX = e.clientX - dragStart.value.x
    const deltaY = e.clientY - dragStart.value.y
    
    dialogPosition.value = {
        position: 'fixed',
        left: (dialogStart.value.left + deltaX) + 'px',
        top: (dialogStart.value.top + deltaY) + 'px',
        transform: 'none'
    }
}

const stopDrag = () => {
    isDragging.value = false
    document.removeEventListener('mousemove', onDrag)
    document.removeEventListener('mouseup', stopDrag)
}

// 监听弹窗显示，重置位置
watch(questionshow, (newVal) => {
    if (newVal) {
        dialogPosition.value = {
            position: 'fixed',
            left: '50%',
            top: '10%',
            transform: 'translateX(-50%)'
        }
    }
})


const questionfun = (type) => {
    questiontype.value = type
    questionshow.value = true


}
//一次核查是否完成
const checkall = ref(false)
//是否开启二次核查
const ischeck2 = ref('是')
// 核查状态
const check_status = ref('')
//第几次核查
const check_round = ref('')
const model = reactive(props.data)

const getval = (key) => {
    return model.fields[key]
}
//核查相关信息
const checkdata = reactive(props.data.checkdata)

// 质疑相关信息
const questiondata = reactive(props.data.questiondata)

const addquestion1 = () => {
    console.log(title, addtextarea.value)
    if(!title.value || !addtextarea.value) return alert('请填写质疑原因和质疑内容')
    
    const data = {
        "field_id":model.id,
        "review_user_id": user.id,
        "inquiry_content":title.value ,//用户可选小标题
        "inquiry_reason": addtextarea.value,//质疑内容
        "period": props.period,
        "title": props.text //固定带参
        }
    commonStore.addquestion(data).then(res=>{
        if(res.result == 'success'){
            res = res.data
            addtextarea.value = ''
            // title.value = ''
            inquiry_reason.value = res.inquiry_reason //质疑原因
            questionmsg.value = res.operations //质疑原因展示
            questionshow.value = false //关闭弹窗
            inquiry_content.value = res.inquiry_content
            question_status.value = res.status //质疑状态
            console.log(res, 'res')
            questionid.value = res.id //新质疑id
        
        }
    })
}

const addquestion = debounceImmediate(addquestion1, 500, true)



const revokequestion1 = () => {

    const data = {
        "id": questionid.value,
        "user_id": user.id,
        "cancellation_reason":revoketextarea.value
    }
    console.log(data, 'data')
    // return
    // debugger
    if(!revoketextarea.value) return alert('请输入撤销质疑原因')
    commonStore.revokequestion(data).then(res=>{
        console.log(res, 'revokequestion')
        if(res.result == 'success'){
            questionid.value =res.data.id
            questionmsg.value = res.data.operations //质疑原因展示
            question_status.value =res.data.status
            questionshow.value = false
            revoketextarea
        }
    })
}
const revokequestion = debounceImmediate(revokequestion1, 500, true)

const processquestion1 = () => {
    const data = {
        "id": questionid.value,
        "user_id": user.id,
        "handling_remark": processtextarea.value
    }
    if(!processtextarea.value) return alert('请输入处理质疑说明')
    commonStore.processquestion(data).then(res=>{
        console.log(res, 'processquestion')
        if(res.result == 'success'){
            question_status.value = res.data.status
            questionmsg.value = res.data.operations //质疑原因展示
            questionid.value =res.data.id
            questionshow.value = false
            processtextarea.value = ''
        }
        else{
            alert(res.msg)
        }
    })
}
const processquestion = debounceImmediate(processquestion1, 500, true)

const closequestion1 = () => {
    commonStore.closequestion({id:questionid.value, user_id:user.id}).then(res=>{
        console.log(res, 'closequestion')
        if(res.result == 'success'){
            question_status.value = res.data.status
            questionmsg.value = res.data.operations //关闭原因展示
            questionid.value =res.data.id
            questionshow.value = false
        }else{
            alert(res.msg)
        }
    })
}
const closequestion = debounceImmediate(closequestion1, 500, true)

const setchec1 = (status) => {
    const data = {
        "field_id": model.id,
        "user_id": user.id,
        "check_round": commonStore.ischecke,
        "check_status": status,
        "period": props.period,
        "title": props.text
    }
    commonStore.setcheck(data).then(res=>{
        console.log(res, 'setcheck')
        if(res.result == 'success'){
            check_status.value = res.data.check_status
            commonStore.is_fully_checked = res.data.is_fully_checked
            // if(res.data.check_status == '0'){
            //     commonStore.allcheckcount--
            // }else{
            //     commonStore.allcheckcount++
            // }
            

            console.log(res.data.check_status,'check_status')
        }else{
            alert(res.msg)
        }
    })
}
//核查状态
const setcheck = debounceImmediate(setchec1 , 500,true)




// watch(()=>commonStore.is_fully_checked, (newVal, oldVal) => {
//     console.log(newVal, oldVal, 'is_fully_checked')
    
//     // console.log(commonStore.allcheckcount,'commonStore.allcheckcount')

// })
watch(()=>commonStore.checkdata, (newVal, oldVal) => {
    console.log(newVal, oldVal, 'newVal, oldVal')
    // debugger
    newVal.data?.forEach(item => {
        if(item.title == props.text){
            check_status.value =  item.check_status
        }
    })
}, { deep: true })

function debounceImmediate(func, delay, immediate = false) {
  let timer;
  return function(...args) {
    const context = this;
    if (immediate && !timer) {
      func.apply(context, args);
    }
    clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      if (!immediate) {
        func.apply(context, args);
      }
    }, delay);
  };
}
const handleClick = debounceImmediate(() => {
  console.log('Button clicked!');
}, 500, true);
 
// 角色：0管理员、1普通医生、2、核查人员

//质疑的状态：0=待处理, 1=已处理, 2=已撤销, 3=已确认
onMounted(() => {
    try {
        console.log(props.data,'props.data')
        // console.log(props.data.checkdata,'checkdata')
        // console.log(questiondata,'questiondata')
        // checkall.value = props.data.checkdata.checkall
        // check_round.value = props.data.checkdata.checkall? '2':'1'
        // ischeck2.value = props.data.checkdata.ischeck2

        props.data.checkdata.data?.forEach(item => {
            // console.log(item,props.text,'item')
            if(item.title == props.text){
                // console.log(item.check_status,'item.check_status')
                check_status.value =  item.check_status
                
            }
        })
        setTimeout(() => {
        }, 1000);
        questiondata?.forEach(item => {
            if(item.title == props.text){
                inquiry_reason.value = item.inquiry_reason
                questionmsg.value = item.operations
                inquiry_content.value = item.inquiry_content
                question_status.value = item.status //该质疑的状态
                questionid.value = item.id
                // console.log(item.question_status,'item.question_status')
            }
        })       
        

    }catch (error) {
        // console.log(error)
    }
})
;
</script>
<style lang="less" scoped>
.site{
    // flex-grow: 1;
    width: 100px;
    position: relative;
    left: 20px;
    height: 100%;
    z-index: 11;

}
.btns{
    display: flex;
    p{
        font-size: 16px;
        color: #fff;
        height: 25px;
        padding:0 10px;
        text-align: center;
         white-space: nowrap;
        border-radius: 5px;
        margin-right: 20px;
    }
    .green{
        background-color: #4ebc17;
    }
    .isgreen{
        background-color: #626462;
    }
    .yellow{
        background-color: #e3d927;
    }
}
.question{
    color: red;
    width: 300px;
    display: flex;
    flex-direction: column;

}
.dialog{
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    inset: 0;
    z-index: 20;
    .box{
        background-color: #fff;
        width: 600px;
        // height: 500px;
        padding-bottom: 60px;
        border-radius: 10px;
        overflow: hidden;
        position: relative;
        .title{
            margin: 0;
            padding:10px 20px;
            background-color: #D84357;
            color: #fff;
            font-size: 20px;
        }
        .draggable-header{
            cursor: move;
            user-select: none;
        }
        .content{
            padding: 0 20px;
            div{
                display: flex;
                p:nth-child(1){
                    width: 100px;
                }
                p:nth-child(2){
                    flex: 1;
                }
            }
        }
        .footer{

            position: absolute;
            width: 100%;
            bottom: 10px;
            display: flex;
            justify-content: center;
            // padding: 20px;
            box-sizing: border-box;
           
        }
    }
}
.hand{
    cursor: pointer;
}
</style>